import React from 'react';
import Sheet, { PILL_BASE, SheetCta, pill } from './Sheet';
import StepTrim from './StepTrim';
import StepCover from './StepCover';

/**
 * TRIM + COVER — the video gate (handoff v3 §4). It opens on NEXT from PICK with a video and
 * cannot be dismissed until USE THIS CLIP: no ✕, a tap on the canvas does nothing, the header's
 * NEXT and the rail are hidden. Afterwards the rail's TRIM button reopens it and it closes like
 * any sheet. TRIM is never skipped, even for a short clip.
 */
export default function TrimCoverSheet({
  locked = true,
  tab = 'trim',
  onTab,
  onClose,
  onConfirm,
  // TRIM
  frames, durationSec, trim, maxClipMs, playSec, loading = false, failed = false, onTrim,
  // COVER
  coverPct, onCoverPct, onCoverSettled, cover, coverFocus, onCoverFocus,
}) {
  return (
    <Sheet title="TRIM + COVER" suffix={locked ? '· REQUIRED' : ''} locked={locked} onClose={onClose} testId="trim-cover-sheet">
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0,1fr))', gap: 6 }}>
        {[['trim', '01 · TRIM'], ['cover', '02 · COVER']].map(([k, l]) => (
          <button key={k} type="button" aria-pressed={tab === k} onClick={() => onTab(k)} style={{ ...PILL_BASE, height: 34, ...pill(tab === k), fontSize: 10, letterSpacing: '0.14em' }}>{l}</button>
        ))}
      </div>
      {tab === 'trim' ? (
        <>
          <StepTrim frames={frames} durationSec={durationSec} trim={trim} maxClipMs={maxClipMs} playSec={playSec} loading={loading} failed={failed} onTrim={onTrim} />
          <SheetCta onClick={() => onTab('cover')} disabled={loading || failed}>NEXT · PICK A COVER</SheetCta>
        </>
      ) : (
        <>
          <StepCover
            frames={frames}
            durationSec={durationSec}
            trim={trim}
            coverPct={coverPct}
            onCoverPct={onCoverPct}
            onCoverSettled={onCoverSettled}
            cover={cover}
            focus={coverFocus}
            onFocus={onCoverFocus}
          />
          <SheetCta onClick={onConfirm} disabled={loading || failed} data-testid="use-this-clip">USE THIS CLIP</SheetCta>
        </>
      )}
    </Sheet>
  );
}
